<template>
  <table>
    <!--
    <tr>
      <td>Nummer</td>
      <td><SogDataLabel :value="orderHead.orderNumber" /></td>
    </tr>
-->
    <tr>
      <td>Datum</td>
      <td>
        <SogDataLabel
          :value="orderHead.orderedDate"
          value-type="DateTime"
        />
      </td>
    </tr>
    <tr>
      <td>Kunde</td>
      <td>
        <SogDataLabel :value="orderHead.personName" />
      </td>
    </tr>
    <tr>
      <td>Lieferant</td>
      <td>
        <SogDataLabel :value="orderHead.supplierName" />
      </td>
    </tr>
    <tr v-show="orderHead.deliveryPersonId">
      <td>Lieferung an</td>
      <td>
        <SogDataLabel :value="orderHead.deliveryPersonName" />
      </td>
    </tr>
    <tr v-show="_isPriceVisible">
      <td>Zahlungsbetrag</td>
      <td>
        <SogDataLabel
          :value="orderHead.orderAmount"
          :value-type="SogDataLabelValueType.Money"
        />
      </td>
    </tr>
    <tr v-show="_isPriceVisible">
      <td>VersSt</td>
      <td>
        <SogDataLabel
          :value="orderHead.insuranceTaxAmount"
          value-type="Money"
        />
      </td>
    </tr>
    <tr>
      <td>Bestellt durch</td>
      <td>
        <SogDataLabel :value="orderHead.orderedByPersonName" />
      </td>
    </tr>
    <tr v-show="orderHead.orderType===OrderType.Invoice">
      <td>Bezahlt</td>
      <td>
        <span
          v-show="orderHead.paid"
          class="e-badge e-badge-success e-badge-pill"
        >ja</span><span
          v-show="!orderHead.paid"
          class="e-badge e-badge-danger e-badge-pill"
        >nein</span>
      </td>
    </tr>
    <tr v-show="payment">
      <td>am</td>
      <td>
        <SogDataLabel
          :value-type="SogDataLabelValueType.Date"
          :value="payment.date"
        />
      </td>
    </tr>
    <tr v-show="payment&&payment.bank">
      <td colspan="2">
        <SogDataLabel
          :value-type="SogDataLabelValueType.String"
          :value="payment.bank"
        />
      </td>
    </tr>
    <tr v-show="payment&&payment.memo">
      <td colspan="2">
        <SogDataLabel
          :value-type="SogDataLabelValueType.String"
          :value="payment.memo"
        />
      </td>
    </tr>
    <tr v-show="orderHead.orderType===OrderType.Order">
      <td>Abgerechnet</td>
      <td>
        <span
          v-show="orderHead.invoiced"
          class="e-badge e-badge-success e-badge-pill"
        >ja</span><span
          v-show="!orderHead.invoiced"
          class="e-badge e-badge-danger e-badge-pill"
        >nein</span>
      </td>
    </tr>
    <tr v-show="orderHead.statusId!==OrderStatus.Completed">
      <td>Status</td>
      <td>
        <SogIcon
          icon="mdi-truck-fast"
        />
      </td>
    </tr>
    <tr v-show="orderHead.invoiceCircle">
      <td>Referenznummer</td>
      <td>
        <SogDataLabel :value="orderHead.invoiceCircle" />
      </td>
    </tr>
  </table>
</template>

<script setup lang="ts">

import OrderHead, {OrderStatus, OrderType} from "@/shared/model/orderHead";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import Payment from "@/shared/model/Payment";

interface Props {
  orderHead?: OrderHead,
  payment?: Payment
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    orderHead: undefined, payment: undefined
  }
)

const _accountStore = useAccountStore();

const {isBranch} = storeToRefs(_accountStore)


const _isPriceVisible = computed(() => {
  return !(isBranch.value)
})


</script>

<style scoped>
td {
  padding-right: 5px;
}
</style>
